import {Component, inject, OnInit} from '@angular/core';
import { ApiEnum } from '../../../../@application/enum/api.enum';
import {ApiBaseService} from '../../../../../../projects/vendors/src/public-api';
import { OnGoingOrder } from '../../../../@domain/on-going-order';
import { OrderStatus } from '../../../../@application/enum/order-status.enum';
import {PendingOrder} from "../../../../@domain/pending-order";
import {DatePipe} from "@angular/common";
import {Router} from "@angular/router";
import {PathEnum} from "../../../../@application/enum/path.enum";

@Component({
    selector: 'app-meta-data',
    templateUrl: './meta-data.component.html',
    styleUrl: './meta-data.component.scss',
    standalone: false
})
export class MetaDataComponent implements OnInit{

  time!: Date;
  totalRevenue = 0
  numberOfOrders = 0
  apiBaseService = inject(ApiBaseService);
  datePipe = inject(DatePipe);
  router = inject(Router);


  ngOnInit(): void {
    this.getTime()
    this.getData();
    this.startDay()

  }

  private startDay(){
    this.apiBaseService.POST_API([ApiEnum.FinancialModule,ApiEnum.DailyReconciliation,ApiEnum.Auto],{},true,false)
      .subscribe({
        next: _response => {}
      })
  }

  getTime() {
    this.time = new Date();
    setInterval(() => {
      this.time = new Date();
    }, 1000);
  }

  private getData() {
    this.apiBaseService.GET<PendingOrder[]>([ApiEnum.RestaurantModule, ApiEnum.CustomerOrder])
      .subscribe({
        next: response => {
          this.numberOfOrders = response.filter(x => this.datePipe.transform(x.createdAt,'yyyy-MM-dd') == this.datePipe.transform(new Date(),'yyyy-MM-dd')).length
        }
      })

  }

  onPendingOrders() {
    this.router.navigate([PathEnum.Home,PathEnum.OtherOrders,PathEnum.PendingOrders])
  }
}
